import { render, staticRenderFns } from "./SLStatementView.vue?vue&type=template&id=484e5659&"
import script from "./SLStatementView.vue?vue&type=script&lang=js&"
export * from "./SLStatementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports